import { DatabaseOutlined, FundViewOutlined, LogoutOutlined, PartitionOutlined } from '@ant-design/icons';
import { FC, ReactNode } from 'react';
import { LoginPage } from '../pages/login';
import { useAuthContext } from '../services/auth.service';
import './layout.scss';
import { Tooltip } from 'antd';

/* -------------------------------------------------------------------------------- *\
|                               LayoutSite
\* -------------------------------------------------------------------------------- */
export const LayoutSite: FC<{ children?: ReactNode }> = (children) =>
{
	var auth = useAuthContext();
	if (!auth || !auth.token)
	{
		return <LoginPage />
	}

	return (
		<div className="layout">
			<div className="layout__sider" >
				<div className="layout__logo">
				<a href="/" ><img src={'/images/logo.png'} alt="McLloyd" /></a>
				</div> 
				<div className="layout__menucont">
					<div className="layout__menu">
						<Tooltip title="Live datas" placement='right' color={'#888888'}><a className='layout__menu__item' href="/datas" ><PartitionOutlined /></a></Tooltip>
					</div>
					<div className="layout__menu layout__menu__bottom">
					<Tooltip title="Logout" placement='right' color={'#888888'}><div className='layout__menu__item' onClick={() => auth.logout()}><LogoutOutlined /></div></Tooltip>
					</div>
				</div>
			</div>
			<div className="layout__content">
				<div className="layout__content__inner">
					<div>{children.children}</div>
					<div className="layout__footer">UDP tester @mclloyd 2025{process.env.REACT_APP_VERSION ? ` - version ${process.env.REACT_APP_VERSION}` : ''}</div>
				</div>
			</div>
	  </div>
	  );
}